import { useAuth } from "@/lib/auth";
import { SignOut, User, Gear } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

/**
 * UserMenu — avatar + dropdown with user info and prominent "Sair" action.
 * Used on both AdminLayout and ClientLayout headers (mobile + desktop).
 */
export const UserMenu = ({ variant = "dark", showSettings = false, settingsPath = "/admin/configuracoes" }) => {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const initials = (user?.name || "?")
    .split(" ")
    .slice(0, 2)
    .map((s) => s[0]?.toUpperCase())
    .join("");

  const isDark = variant === "dark";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="user-menu-trigger"
          className={`w-9 h-9 rounded-full grid place-items-center font-display font-semibold border transition-colors ${
            isDark
              ? "bg-zinc-800 text-amber-300 border-zinc-700 hover:bg-zinc-700"
              : "bg-zinc-100 text-zinc-900 border-zinc-200 hover:bg-zinc-200"
          }`}
          aria-label="Menu da conta"
        >
          {initials || <User size={16}/>}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel className="font-normal">
          <div className="flex flex-col gap-0.5 py-1">
            <span className="text-sm font-semibold text-zinc-900 truncate">{user?.name}</span>
            <span className="text-xs text-zinc-500 truncate">{user?.email || `@${user?.username}`}</span>
            <span className="text-[10px] tracking-widest uppercase text-zinc-400 mt-1">
              {user?.role === "admin" ? "Administrador" : "Cliente"}
            </span>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {showSettings && (
          <DropdownMenuItem onClick={() => nav(settingsPath)} data-testid="user-menu-settings">
            <Gear size={16} className="mr-2"/>
            Configurações
          </DropdownMenuItem>
        )}
        <DropdownMenuItem
          onClick={logout}
          data-testid="user-menu-logout"
          className="text-rose-600 focus:text-rose-700 focus:bg-rose-50"
        >
          <SignOut size={16} className="mr-2"/>
          Sair da conta
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserMenu;
